<template>
  <!-- Figma "Payment Failed": card declined at checkout (replaces the "Your card was declined." toast) -->
  <div ref="modal" class="modal fade fxModal fxConfirm" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 420px">
      <div class="modal-content">
        <div class="modal-body p-[15px] font-roboto">
          <FxModalHeader title="Payment Failed" :dismiss="false" @close="close" headerClass="text-[#C43333]" />
          <div class="flex flex-col gap-[20px]">
            <div class="flex flex-col gap-[15px] items-center text-center">
              <span class="w-[66px] h-[66px] flex items-center justify-center rounded-full bg-[#FDECEC]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                  class="w-[26px] h-[26px]">
                  <path d="M10.3 3.9 2.4 17.6A2 2 0 0 0 4.1 20.6h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
                    fill="#E23D3D" />
                  <path d="M12 9v4.5" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                  <circle cx="12" cy="16.8" r="1.1" fill="#FFFFFF" />
                </svg>
              </span>
              <p class="m-0 font-roboto text-[16px] font-semibold text-[#2E3138]">The card was declined by the issuing
                bank.
              </p>
              <p class="m-0 font-roboto font-normal text-[14px] text-[#5B616B]">No charge has been made and the invoice
                is still open.
              </p>
              <span v-if="reason"
                class="px-[10px] py-[3px] rounded-[6px] bg-[#FDECEC] text-[12px] font-roboto font-semibold text-[#C43333]">
                {{ reason }}
              </span>
            </div>
            <div class="flex flex-col gap-[7px] p-[12px] rounded-[10px] bg-[#F7F8FA]">
              <p class="m-0 text-[14px] font-roboto font-bold text-[#2E3138]">What you can do next</p>
              <ul class="m-0 list-inline font-roboto text-[14px] flex flex-col gap-[10px] text-[#5B616B]">
                <li class="flex items-start gap-[5px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                    class="text-[8px] min-w-[10px] relative top-[6px] text-[#F15A14]">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M4.8 21.57L7.222 24L19.2 12L7.222 0L4.8 2.43L14.347 12z" />
                  </svg>
                  <span>Ask the consumer to confirm the card details and available balance.</span>
                </li>
                <li class="flex items-start gap-[5px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                    class="text-[8px] min-w-[10px] relative top-[6px] text-[#F15A14]">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M4.8 21.57L7.222 24L19.2 12L7.222 0L4.8 2.43L14.347 12z" />
                  </svg>
                  <span>Try the payment again with the same card.</span>
                </li>
                <li class="flex items-start gap-[5px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                    class="text-[8px] min-w-[10px] relative top-[6px] text-[#F15A14]">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M4.8 21.57L7.222 24L19.2 12L7.222 0L4.8 2.43L14.347 12z" />
                  </svg>
                  <span>Choose another method — cash, check or financing.</span>
                </li>
              </ul>
            </div>
            <div class="flex justify-center gap-[10px] mt-[20px]">
              <button type="button" class="fxBtnSecondary" @click="choose('another-method')">Choose Another
                Method</button>
              <button type="button" class="fxBtnPrimary !bg-[#F67280] !border-[#F67280]"
                @click="choose('try-again')">Try
                Again</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import FxModalHeader from "../nest_components/FxModalHeader.vue";

export default {
  components: { FxModalHeader },
  emits: ["another-method", "try-again"],
  data() {
    return { reason: "" };
  },
  beforeUnmount() {
    Modal.getInstance(this.$refs.modal)?.dispose();
  },
  methods: {
    // reason: the decline code / gateway message shown in the red chip
    open(reason) {
      this.reason = reason || "";
      Modal.getOrCreateInstance(this.$refs.modal).show();
    },
    close() {
      Modal.getInstance(this.$refs.modal)?.hide();
    },
    choose(event) {
      this.close();
      this.$emit(event);
    },
  },
};
</script>
